import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IGetNetworkDetailActionParams } from "../../../Orchestrator/Types/Index";

class StationMoreDetailClickAction extends BaseAction<void, IGetNetworkDetailActionParams> {
  override async run(): Promise<void> {

    try {
      const { slug } = this.params!;
      _eventBus.emit({
        eventName: "FLOW_CLOSE",
        data: `NetworkMapStationFlow`,
      });

      updateRecoilState("networkDetailResponseAtom", null)
      _eventBus.emit({
        eventName: "ROUTE_CHANGE",
        data: `/networks-maps-stations/${slug}`,
      });
    } catch (error: any) {
      console.error("Error fetching stationData:", error);
    } finally {

    }
  }
}

export const stationMoreDetailClickAction = new StationMoreDetailClickAction();
